const initialState = {
    data: [],
    total: 1,
    params: {},
    allData: []
  }
  
  const invoiceReducerPagos = (state = initialState, action) => {
    switch (action.type) {
      case 'GET_DATA_PAGOS':
        return {
          ...state,
          allData: action.allData,
          data: action.data,
          total: action.totalPages,
          params: action.params
        }
      case 'DELETE_INVOICE_PAGOS':
        return { ...state }
      default:
        return { ...state }
    }
  }
  export default invoiceReducerPagos
  